import React from 'react'
import {
  ActivityHistoryRowType,
  ActivityHistoryTypeEnum
} from '../activityHistoryTypes'
import ActivityHistoryEventName from './ActivityHistoryEventName'
import ActivityHistoryResourceName from './ActivityHistoryResourceName'
import ActivityHistoryCPDName from './ActivityHistoryCPDName'

type ActivityHistoryTableNameProps = ActivityHistoryRowType

const ActivityHistoryTableName = (props: ActivityHistoryTableNameProps) => {
  switch (props.__typename) {
    case ActivityHistoryTypeEnum.CPDManualEntryModel:
      return (
        <ActivityHistoryCPDName
          name={props.name}
          description={props.description}
          downloadLink={props.document_cdn_url || ''}
        />
      )
    case ActivityHistoryTypeEnum.TopicEnrolmentModelAsStudent:
      return (
        <ActivityHistoryResourceName
          originSection={props.originSection}
          topicVersion={props.topicVersion}
          topicId={props.topic_id}
          isArchived={
            !!props?.deleted_at ||
            !!props.topic?.deleted_at ||
            !!props.originSection?.deleted_at
          }
        />
      )
    case ActivityHistoryTypeEnum.UserEventModel:
      return (
        <ActivityHistoryEventName
          title={props.event.title}
          name={props.certification?.name}
          hasCertification={!!props.certification}
          id={props.event.id}
          isArchived={!!props.event.deleted_at}
        />
      )
    default:
      return null
  }
}

export default React.memo(ActivityHistoryTableName)
